// Utilidad nativa de Tailwind 3, sin plugin. En el navegador no se ve nada;
// en el PDF corta la página.
export const PageBreak = () => <div className='break-after-page' />
